import { useQuery } from '@apollo/client';

import { EVENT_USERS } from '../graphql/query/eventUsersQuery.graphql';

export const useEventUsersQuery = (
  eventId: string | null,
  hasPaid?: boolean | null,
) => {
  return useQuery(EVENT_USERS, {
    variables: { eventId: eventId ?? '', hasPaid },
    skip: !eventId,
  });
};
